import React, { Component } from 'react'
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";

import './App.css'

import UnmuteButton from 'unmute'
import LALThreeEngine from './LALThreeEngine'
import ATSThreeEngine from './ATSThreeEngine'
import CoMLogo from './assets/CoM_Secondary_A_black.png'



/*
routing : 2 pages

clean up site and setup
url!
nginx multiple sites : dir structure
weebly : embed another page


side compression for voices


video compression ;

ffmpeg -i 05_converted.mp4 -vcodec libx264 -pix_fmt yuv420p -an -profile:v baseline -level 3 -filter:v scale=640x360 05_comp.mp4


*/


/* DEPLOY

server
  root@172.105.175.89
  pw : ZXzxzx72


1.  build 

 
2. 
   sudo scp -r Develop/JS/Projects/my-app/build/* root@172.105.175.89:/var/www/html
    copy build files over to server

   sudo scp -r Develop/Web/ATYH/atyh/build/* root@172.105.175.89:/var/www/html

    

3.  nginx server link (for new site )
    sudo unlink /etc/nginx/sites-enabled/xxxxOLDxxx
    sudo ln -s /root/test/build/xxxxNEWxxxx /etc/nginx/sites-enabled/
    test
    sudo nginx -t
    reload
    sudo nginx -s reload





    builds script 

    sudo scp -r dist/*  root@172.105.175.89:/var/www/html
    

    gpwp % sudo scp -r dist/*  root@172.105.175.89:/var/www/html



    ffmpeg -i 01_converted.mp4 -i 02_converted.mp4 \
-filter_complex "[0:v:0] [0:a:0] [1:v:0] [1:a:0] concat=n=2:v=1:a=1 [v] [a]" \
-map "[v]" -map "[a]" 0102.mp4
*/

//--------------------------------------------------------------------
//
//--------------------------------------------------------------------
export const Header = (props: {
}) => {
  return <header className="App-header">
    <p className="title">all that you hear is all that is heard</p>
    
  </header>
}

export const Footer = (props: {
}) => {
  return <div >
         <p className="titleb">an interactive visual & deep listening expereince</p>
   <p className="by">by the letter string quartet & takeshi kondo</p>
    <p  className="byb">Supported by the City of Melbourne COVID-19 Arts Grants</p>
    <img className="com-logo" src={CoMLogo} alt="" />
  </div>

}


//--------------------------------------------------------------------
//
//--------------------------------------------------------------------
export const One = (props: {
}) => {

  return <div>
      <LALThreeEngine />
    </div>

}

export const Two = (props: {
}) => {

  return <div>
      <ATSThreeEngine />
    </div>

}

//--------------------------------------------------------------------
//
//--------------------------------------------------------------------

class App extends Component {

  componentDidMount() {
    UnmuteButton()
  }

  render() {
    return (
      <Router>
        <div className="App" >
          <Switch>
            <Route exact path="/layeruponlayer">
              <Header />
              <One />
              <Footer />
            </Route>
            <Route exact path="/alwaysthesame">
              <Header />
              <Two />
              <Footer />
            </Route>
          </Switch> 
        </div>
      </Router>
    )
  }
}

export default App
